import React from 'react'
import '../../styles/flash-media.sass'
import file from '../../img/File icon.svg'
import { useHistory } from 'react-router-dom'
import { files } from '../files'

const FlashMediaComponent = () => {
  const history = useHistory()

  return (
    <div className='flash-media'>
      <p className='title'>Description</p>
      The «FlashMedia» software is designed to provide services for placing the user's advertising content and delivering it to the end user through media devices.
      <p className='title'>Functions</p>
      The «FlashMedia» software provides two-way user interaction with the program and performs the following tasks:
      <br/>1) formation of orders for the display of advertising content;
      <br/>2) moderation of orders for displaying advertising content;
      <br/>3) payment for an order to display advertising content;
      <br/>4) management of tariffs for displaying advertising content;
      <br/>5) management of platforms for displaying advertising content;
      <br/>6) management of playlists of platforms for displaying advertising content;
      <br/>7) displaying the status of advertising content playback devices;
      <br/>8) user management and provision of differentiation of access rights to the program functionality.
      <p className='title'>System requirements</p>
      <div className='table'>
        <table>
          <tr>
            <th><div>Component</div></th>
            <th><div>Parameter</div></th>
          </tr>
          <tr><td><div>CPU</div></td><td><div>Intel with a clock speed of 3.6GHz or more</div></td></tr>
          <tr><td><div>RAM</div></td><td><div>8GB SDRAM or more</div></td></tr>
          <tr><td><div>HDD</div></td><td><div>120GB SSD or more</div></td></tr>
          <tr><td><div>Graphics card</div></td><td><div>Integrated on motherboard</div></td></tr>
          <tr><td><div>Network interface controller</div></td><td><div>Ethernet at least 100Mbps</div></td></tr>
          <tr><td><div>Optional equipment</div></td><td><div>SVGA 1920x1080 display, mouse, keyboard</div></td></tr>
          <tr><td><div>Internet access</div></td><td><div>Permanent access to the network at least 100Mbps</div></td></tr>
        </table>
      </div>
      <p className='title'>Documentation and files</p>
      <div className='files' onClick={() => {
        window.open(`${files.install}`, '_blank')
      }}>
        <img src={file} alt='file-icon' /><p>Installation instructions</p>
      </div>
      <div className='files' onClick={() => {
        window.open(`${files.manual}`, '_blank')
      }}>
        <img src={file} alt='file-icon' /><p>Manual</p>
      </div>
      <div className='files' onClick={() => {
        window.open(`${files.functional}`, '_blank')
      }}>
        <img src={file} alt='file-icon' /><p>Description of functional characteristics</p>
      </div>
      <div className='files' onClick={() => {
        window.open(`${files.processes}`, '_blank')
      }}>
        <img src={file} alt='file-icon' /><p>Life cycle processes</p>
      </div>
      {/* <a className='files' href={`${files.prFiles}`} download>
        <img src={file} alt='file-icon' /><p>Program files</p>
      </a> */}
      <p className='title'>Cost</p>
      Software cost calculation is carried out individually. Leave a request and our manager will contact you.
      <br/>
      <br/>
      <div className='button button__default'>
        <button onClick={() => {
          history.push('/feedback')
        }}>Request the cost</button>
        <div className='background'></div>
      </div>
    </div>
  )
}

export default FlashMediaComponent